<template>
  <div class="py-5 text-center">
    <h1>Page Not Found</h1>
    <p class="text-lead">
      The page you are looking for does not exist or may have moved.
    </p>

    <b-button
      @click.prevent="() => router.push({ name: 'Dashboard' })"
      size="md"
      variant="primary"
      >Back to Dashboard</b-button
    >
  </div>
</template>

<script>
import Vue from 'vue'
import { defineComponent, onMounted } from '@vue/composition-api'
import { useRouter } from 'vue2-helpers/vue-router'

export default defineComponent({
  name: 'PageNotFound',
  title: 'Page Not Found',
  setup() {
    const router = useRouter()

    onMounted(() => {
      Vue.prototype.$emitter.on('logged-out', (success) => {
        if (!!success) router.push({ name: 'Home' })
      })
    })

    return {
      router
    }
  }
})
</script>
